import { useEffect } from 'react'

import { useNavigate, Outlet } from 'react-router-dom'
import { HStack, VStack, Heading, Center, Button } from '@chakra-ui/react'
import { toast } from 'react-toastify'

const DashboardPage = () => {
  const navigate = useNavigate()
  return (
    <HStack align="flex-start" h="100%" p="10">
      <VStack>
        <iframe
          title="Welcome"
          width="1200"
          height="800"
          src="https://app.powerbi.com/reportEmbed?reportId=529be9be-ee59-4636-bbdc-ec6fe316ac97&autoAuth=true&ctid=12a4a6bc-71c2-4f33-888c-1bd8600573bc"
          frameBorder="0"
          allowFullScreen="true"
        ></iframe>
      </VStack>
    </HStack>
  )
}

export default DashboardPage
